import { showGlobalDialogError } from "../components/error";
import { BASE_URL } from "../utils/constants";
import handler from "../utils/handler";
import { apiClient } from "./apiClient.services";

export const RequestAccessToken = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/auth/openid-connect/seller-token`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		if (response.status === 502) {
			showGlobalDialogError('Service Unavailable', 'We’re having trouble reaching the server. Please try again.');
		};

		let result = handler(response)

		if (response.ok) {
			await result.then((data) => {
				localStorage.setItem("accessToken", data.access_token);
				localStorage.setItem("userName", `${data.firstName}`);
				localStorage.setItem("businessEncryptedId", data.businessEncryptedId);
				localStorage.setItem("currencyCode", data.currencyCode);
				localStorage.setItem("factorStartDate", data.factorStartDate);
				localStorage.setItem("uniqueId", data.userUniqueId);
				localStorage.setItem("businessOwnerIdType", data.businessOwnerIdType);
				localStorage.setItem("businessName", data?.customerData?.businessName);
			});

			const accessToken = localStorage.getItem("accessToken");
			const userName = localStorage.getItem("userName");

			if (accessToken !== null || userName !== null) {
				return { response, result };
			}
		} else {
			return { response, result };
		}

	} catch (error) {
		showGlobalDialogError();
		return {
			response: { status: 500 },
			result: Promise.resolve({ message: error.message }),
			error: true,
		};

	}
}

export const GetResetPassword = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/notifications/resetPassword?email=${value}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		let result = handler(response)

		return {response, result};

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const ResetPasswordTokenVerify = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/notifications/token/verify?token=${value}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		let result = handler(response)

		return {response, result};

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const PostResetPassword = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/notifications/resetPassword`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response)

		return {response, result};

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GenerateOtpCode = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/token/otp/generate`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response)

		return {response, result};

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const VerifyOtpCode = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/token/otp/verify`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = await handler(response)

		return {response, result};

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetUserDetails = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/userDetails?userUniqueId=${value}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		let result = handler(response)

		if (response.ok) {
			await result.then((data) => {
				localStorage.setItem("uniqueId", data.uniqueId)
				localStorage.setItem("country", data.country);
			});
		} else {
			return result;
		}

		return result;

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}


export const SellerSignUp = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/seller`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response)

		if (response.ok) {
			await result.then((data) => {
				localStorage.setItem("uniqueId", data.uniqueId)
			});
		} else {
			return response;
		}

		return response;

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const PlatformAuth = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/platformauth`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response)
		if (result.ok) {
			await result.then((data) => {
				localStorage.setItem("uniqueId", data.uniqueId)
				localStorage.setItem("platformId", data.platformId)
				localStorage.setItem("businessDetails", data.businessDetails)
			});
		} else {
			return response;
		}


	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const ConfirmEmail = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/notifications/verifyEmail?code=${value}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		let result = handler(response)

		if (response.ok) {
			await result.then((data) => {
				localStorage.setItem("uniqueId", data.uniqueId)
			});
		} else {
			return response;
		}

		return response;

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const OnboardingLogin = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/login`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response)

		return { response, result };


	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const PostBusinessInfomation = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/business`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		let result = handler(response);

		if (response.ok) {
			await result.then((data) => {
				localStorage.setItem("onboardingBusinessEncryptedId", data.encryptedId)
			});
			return response;
		} else {
			return result;
		}
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const PostBankInfomation = async (value) => {
	try {
		let response = await fetch(`${BASE_URL}/core/onboard/bank`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(value)
		});

		return response;

	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const PostDocumentUpload = async (filesArray) => {
	const documentTypes = [
		"ID_FRONT",
		"ID_BACK",
		"PROOF_OF_RESIDENTIAL",
		"PROOF_OF_BANK_1",
		"PROOF_OF_BANK_2", 
		"PROOF_OF_BANK_3",
		"PROOF_OF_BUSINESS"
	];

	try {
		const formData = new FormData();
		const fileMetadataArray = [];	
		filesArray.forEach((file, index) => {
			if (file) {
				formData.append('images', file);
				fileMetadataArray.push(documentTypes[index]);
			}
		});
		formData.append('attachmentTypes', JSON.stringify(fileMetadataArray));

		const businessEncryptedId = localStorage.getItem("onboardingBusinessEncryptedId") ?? localStorage.getItem("businessEncryptedId");
		formData.append("businessEncryptionId", businessEncryptedId);
		let response = await fetch(`${BASE_URL}/core/attachments?uploadType=ONBOARDING_BUSINESS_DOCUMENTS`, {
			method: "POST",
			body: formData,
		});

		return response.ok ? response : Promise.reject(await response.json());
	} catch (error) {
		console.error('Error', error);;
	}
};

export const PostAgreementUpload = async (file) => {
	const documentType = 'BUSINESS_AGREEMENT';

	try {
		const formData = new FormData();
		formData.append('images', file);
		formData.append('attachmentTypes', JSON.stringify(documentType));

		const businessEncryptedId = localStorage.getItem("businessEncryptedId");
		formData.append("businessEncryptionId", businessEncryptedId);
		let response = await fetch(`${BASE_URL}/core/attachments?uploadType=BUSINESS_AGREEMENT`, {
			method: "POST",
			body: formData,
		});

		return response.ok ? response : Promise.reject(await response.json());
	} catch (error) {
		console.error('Error', error);;
	}
};

export const GetBusinessList = async(value) => {
	try {
		return await apiClient("/admin/dashboard/businessList");
	} catch (e) {
		throw e;
	}
}
